import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './LandingCast.css';

class LandingCast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCastOpen: false
        };
    }

    render() {
        return (
            <React.Fragment>
                {this.props.event.artists.length > 0 &&
                <div className="showtix-event__cast-section">
                        <div className="showtix-event__cast">
                            <div className="showtix-event__cast__mask is-active">
                                <div className="row">
                                    {this.props.event.artists.map((artist, i) =>
                                        <div
                                            key={i}
                                            className="col-12 col-sm-6 col-md-4 text-center">
                                            <p><strong>{artist.position}</strong><br />{ReactHtmlParser(artist.first_name)} {ReactHtmlParser(artist.last_name)}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                </div>
                }
            </React.Fragment>
        );
    }
}

LandingCast.propTypes = {
    
}

export default LandingCast;


// WEBPACK FOOTER //
// ./src/components/EventLanding/LandingCast/LandingCast.js